import {useEffect, useState} from "react"

import Nav from "../../component/Nav/Nav"
import Footer from "../../component/Footer/Footer"
import SubBanner from "../../component/SubBanner/SubBanner"
import TermsModal from "../../component/Modal/TermsModal"
import {
	getDateStr,
	retrieveData,
	sendFormRequest,
	sendRequest,
	setImageFormData,
	validateEmail,
	validatePhone
} from "../../common";
import {useNavigate} from "react-router-dom";

function Inquire() {

	const navigate = useNavigate()

	const [termsOpen, setTermsOpen] = useState(false)
	const showTerms = () => {
		setTermsOpen(true)
	}

	const [user, setUser] = useState()
	const [phone, setPhone] = useState()
	const [email, setEmail] = useState()
	const [date, setDate] = useState(new Date())
	const [title, setTitle] = useState()
	const [content, setContent] = useState()
	const [image, setImage] = useState()
	const [agreeTerm, setAgreeTerm] = useState()

	let isLoading = false

	const saveInquiry = (e) => {
		e.preventDefault()
		if (isLoading) return
		isLoading = true

		if (!phone?.length || !email?.length) {
			alert('연락처와 이메일은 필수 입력 항목 입니다.')
			isLoading = false
			return
		}

		if (!phone?.startsWith('010') || phone.length !== 11) {
			alert('잘못된 휴대폰 번호입니다. 다시 입력해주세요.')
			return
		}

		if (!agreeTerm) {
			alert('약관에 동의해 주세요.')
			isLoading = false
			return
		}

		sendRequest('common/inquiry/', 'POST', {
			user: user?.id,
			phone,
			email,
			date,
			title,
			content,
			agreeTerm
		}, data => {
			if (image) {
				saveImage(data?.id, image)
			} else {
				saveComplete()
			}
		}, (data, code) => {
			isLoading = false
		})
	}

	const saveImage = (id, image) => {
		const formData = new FormData()
		formData.append('image', image)
		sendFormRequest(`common/inquiry-image/${id}/`, 'POST', formData, data => {
			saveComplete()
		}, (data, code) => {
			isLoading = false
		})
	}

	const saveComplete = () => {
		alert('성공적으로 문의가 접수 되었습니다.')
		navigate(-1)
		isLoading = false
	}

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
			if (!user?.id) {
				if (window.confirm('로그인을 해주세요.')) {
					navigate('/sign-in')
				}
			}
		})
	}, [])

	return (
		<>
			<Nav user={user}/>
			<SubBanner
				title={"검사 문의 및 의뢰"}
				firstText={"검사 문의 및 의뢰 등록 시"}
				lastText={"인컬리지 담당자가 빠른 시간 내에 연락드리겠습니다."}
			/>

			<div className="container">
				<div className="cardContent">
					<form className="cardForm" name="inquire">
						<div className="formFlex">
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">이메일 계정</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="email" name="emailId" defaultValue={user?.email} disabled />
										</span>
									</div>
								</div>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">연락처 *</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="tel" name="tel" placeholder="연락처를 입력해주세요" required value={phone} onChange={e => setPhone(e.target.value?.replace(/[^\d]/,''))} onBlur={() => validatePhone(phone, setPhone)} maxLength={12}/>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="formFlex">
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">답변받을 이메일 *</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="email" name="email" placeholder="example@example.com" required value={email} onChange={e => setEmail(e.target.value)} onBlur={() => validateEmail(email, setEmail)}/>
										</span>
									</div>
								</div>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">날짜</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input disabled={true} value={getDateStr(date)} type="date" name="date" required onChange={e => {
												// console.log(e.target.value)
												setDate(e.target.value)
											}}/>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="formWrap">
							<div className="formItem">
								<div className="formHead">
									<span className="formName">제목</span>
								</div>
							</div>
							<div className="formItem">
								<div className="formBody">
									<span>
										<input type="text" name="title" placeholder="제목을 입력해주세요" required value={title} onChange={e => setTitle(e.target.value)}/>
									</span>
								</div>
							</div>
						</div>
						<div className="formWrap">
							<div className="formItem">
								<div className="formHead">
									<span className="formName">문의 내용</span>
								</div>
							</div>
							<div className="formItem">
								<div className="formBody">
									<span>
										<textarea name="" id="" placeholder="문의내용을 입력해주세요" required value={content} onChange={e => setContent(e.target.value)}></textarea>
									</span>
								</div>
							</div>
						</div>
						<div className="formWrap">
							<div className="formItem">
								<div className="formHead">
									<span className="formName">사진 첨부</span>
								</div>
							</div>
							<div className="formItem">
								<div className="formBody">
									<span className="formFile">
										<input className="fileName" placeholder={image?.name ? image?.name : "파일 선택"} readOnly />
										<label htmlFor="file">파일 찾기</label>
										<input type="file" id="file" accept="image/jpg, image/png, image/jpeg" required onChange={e => {
											// console.log(e.target.files[0])
											setImage(e.target.files[0])
										}} />
									</span>
								</div>
							</div>
						</div>
						<div className="formWrap">
							<div className="formCheckbox">
								<input type="checkbox" id="psInfo" required value={agreeTerm} onChange={e => setAgreeTerm(e.target.checked)}/>
								<label htmlFor="psInfo"></label>
								<span>
									<b onClick={showTerms}>개인정보 수집 및 이용</b>에 동의합니다.
								</span>
							</div>
						</div>
						<button type="submit" className="submitBtn" onClick={saveInquiry}>
							문의하기
						</button>
					</form>
				</div>
			</div>

			{termsOpen && (
				<TermsModal
					setTermsOpen={setTermsOpen}
					title={"개인정보 수집 및 이용에 관한 안내"}
					text={
						"제 3조 개인정보의 제3자 제공에 관한 사항 \n 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다. \n 개인정보를 제3자에게 제공하는 경우 다음의 항목을 이용자에게 알린 후 동의를 받겠습니다. \n "
					}
				/>
			)}

			<Footer />
		</>
	)
}

export default Inquire
